<template>
	<AccordionRoot class="blocks" :multiple="true" :persistent="false">
		<template v-for="(block, index) in blocks" :key="index">
			<AccordionItem v-if="block.rows.length > 0" class="block" :value="`block-${index}`" :title="block.title" ghost>
				<div class="content">
					<div v-for="detailRow in block.rows" :key="detailRow.label" class="detail">
						<span class="label">{{ detailRow.label }}</span>
						<ExpandableText class="value" :text="detailRow.value" />
					</div>
				</div>
			</AccordionItem>
			<span v-else class="block title">{{ block.title }}</span>
		</template>
	</AccordionRoot>
</template>

<script setup lang="ts">
import AccordionRoot from "@/components/ui/AccordionRoot.vue"
import AccordionItem from "@/components/ui/AccordionItem.vue"
import ExpandableText from "@/components/ui/ExpandableText.vue"
import type { ZoneDetails } from "@/utils/parcelZoning"

defineProps<{
	blocks: ZoneDetails["blocks"]
}>()
</script>

<style scoped>
.blocks {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
	padding-top: var(--spacing-xs);
}

.block {
	padding: var(--spacing-xs) var(--spacing-sm);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-lg);
	background: var(--neutral-50);

	&.title {
		color: var(--neutral-900);
		font-family: var(--font-family-primary);
		font-size: var(--font-size-small);
		font-weight: var(--font-weight-medium);
	}

	.content {
		display: flex;
		flex-direction: column;

		.detail {
			display: flex;
			flex-wrap: wrap;
			gap: var(--spacing-xxs) var(--spacing-sm);
			padding: 6px 0;
			justify-content: space-between;
			align-items: baseline;
			border-bottom: var(--border-width-thin) solid var(--neutral-200);

			&:last-child {
				border-bottom: none;
			}

			.label {
				flex: 1 1 var(--min-width-field);
				color: var(--neutral-600);
				font-family: var(--font-family-primary);
				font-size: var(--font-size-small);
				font-weight: var(--font-weight-medium);
				line-height: var(--line-height-normal);
			}

			.value {
				color: var(--neutral-900);
				font-family: var(--font-family-primary);
				font-size: var(--font-size-small);
				font-weight: var(--font-weight-regular);
				line-height: var(--line-height-normal);
			}
		}
	}
}
</style>
